import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import styled from 'styled-components';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

const Divider = styled.div`
    border: 1px solid #EBEBEC;
`

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export interface IModalProps {
    onClose: Function, 
    open: boolean, 
    title:string, 
    children:React.JSX.Element,
    fullwidth?: boolean
    maxWidth?: false | undefined | Breakpoint
    floatRight?: Boolean,
    disableBackdropClick?: boolean
}
export type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | 'xs' ;

function Modal({ onClose, open, title, children, fullwidth, maxWidth, floatRight,disableBackdropClick }: IModalProps) {

    const closeHanler = () => {
        onClose(false)
    };

    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullWidth={fullwidth}
                maxWidth={maxWidth}
                TransitionComponent={Transition}
                keepMounted
                onClose={(event, reason) => {if (disableBackdropClick && reason === 'backdropClick') { return; } closeHanler(); }}
                aria-describedby="alert-dialog-slide-description"
                sx={ floatRight ? {
                    '& .MuiDialog-container': {
                      justifyContent: 'flex-end',
                    }
                } : {}}
            >
                <DialogTitle>
                    {title}
                </DialogTitle>
                    <IconButton sx={{mr:'auto', position:'absolute', top:10, right:10}} onClick={closeHanler}><Close /></IconButton>
                <Divider />
                <DialogContent>
                    {open && children}
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}

export default Modal